var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.666 46.288c-16.146 0-143.103 123.087-143.103 123.087H25.745c-7.51 0-13.556 6.843-13.556 15.342v143.327c0 8.499 6.046 15.341 13.556 15.341h95.516s123.092 117.637 138.405 117.637c18.422 0 33.25-18.854 33.25-42.277V88.568c0-23.423-14.828-42.28-33.25-42.28z",
    fill: "#fff",
    paintOrder: "stroke fill markers"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.129 82.06a16.193 16.193 0 00-12.543 5.784 16.193 16.193 0 001.996 22.814 192.39 192.39 0 0168.736 147.404 192.39 192.39 0 01-68.736 147.405 16.193 16.193 0 00-1.996 22.812 16.193 16.193 0 0022.812 1.996 224.84 224.84 0 0080.305-172.212A224.84 224.84 0 00411.398 85.85a16.193 16.193 0 00-10.27-3.79z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#fff",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.867 135.305a16.193 16.193 0 00-12.205 5.783 16.193 16.193 0 001.996 22.812 122.888 122.888 0 0143.908 94.162 122.89 122.89 0 01-43.908 94.163 16.193 16.193 0 00-1.996 22.812 16.193 16.193 0 0022.813 1.996 155.338 155.338 0 0055.476-118.97c0-45.897-20.318-89.47-55.476-118.971a16.193 16.193 0 00-10.608-3.787z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#fff",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.553 188.547a16.193 16.193 0 00-12.543 5.783 16.193 16.193 0 001.996 22.815 53.383 53.383 0 0119.082 40.917c0 15.8-6.979 30.763-19.082 40.918a16.193 16.193 0 00-1.996 22.813 16.193 16.193 0 0022.812 1.996 85.833 85.833 0 0030.65-65.726 85.833 85.833 0 00-30.65-65.727 16.193 16.193 0 00-10.27-3.79z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#fff",
    paintOrder: "stroke fill markers"
  }));
}
export default "data:image/svg+xml;base64,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";
export { SvgIconUnmute as ReactComponent };